module.exports = __webpack_public_path__ + "img/first_single--active.362076b9.svg";